import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  scrollable: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflowX: 'scroll'
  },
  chip: {
    margin: '0 5px'
  }
});